import { Updater, Widget } from "widgets-for-react"
import { ProductApiResponseParsed, ProductFormState } from "../productFormBlock.state"
import { productSaleSegment } from "./productSale.segment"
import { productSaleDonationSegment } from "./productSaleDonation.segment"
import { productPostageSegment } from "./productPostage.segment"

export const formSegmentWidget = (state: ProductApiResponseParsed, rootState: ProductFormState): Widget<Updater<ProductApiResponseParsed>> => {
  if (state.productForm.kind === "product_sale") {
    const form = state.productForm
    return productSaleSegment(form)
  }

  if (state.productForm.kind === "product_sale_donation") {
    const form = state.productForm
    return productSaleDonationSegment(form, rootState)
  }

  if (state.productForm.kind === "product_package_costs") {
    const form = state.productForm
    return productPostageSegment(form, rootState)
  }

  throw "impossible" as never
}
